import MockupListWithCreate from './MockupListWithCreate'

export default MockupListWithCreate
